import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { useState, useEffect } from 'react';

export const SBDatePicker = (props) => {
    const { value, onChange ,onBlur,onClose} = props;
    const [dateValue, setDateValue] = useState(value);

    useEffect(() => {
        if (value && !moment(value).isSame(dateValue)) {
            setDateValue(value);
        }
    }, [value, dateValue]);

    const datePickerChange = (newDate) => {
        setDateValue(newDate);
        if (onChange && newDate) {
            onChange(newDate);
        }
    };
    const handleOnBlur=(e)=>{
        const dateString=e?.target?.value || ""
        const formarttedDate = convertToJsDate(dateString);
        if(formarttedDate!="Invalid Date")
        {
            const momentDate = moment(formarttedDate);
            if(onBlur)
            {
                onBlur(momentDate);
            }
        }
      
    };
    const handleOnClose=(e)=>{
        const dateString=e?.target?.value || ""
        const formarttedDate = convertToJsDate(dateString);
        if(formarttedDate!="Invalid Date")
        {
            const momentDate = moment(formarttedDate);
            if(onClose)
            {
             onClose(momentDate);
            }
        }
    };
    return (
        <DatePicker
            value={dateValue }
            onChange={datePickerChange}
            views={['year', 'month', 'day']}
            slotProps={{
                textField: {
                  error: false,
                  onBlur:handleOnBlur,
                },
              }}
              onClose={handleOnClose}
            {...props}
        />
    );
};
const convertToJsDate = (dateString) => {
    const [month, day, year] = dateString.split('/').map(Number);
    return new Date(year, month - 1, day);
};